<template>
    <div class="edit-settlement">
        <PageContent class="batch-edit-wrapper">
            <span class="summary-title">
                Please review and confirm your submission
            </span>
            <PanelV2
                type="w6"
                title="BDO Settlement Account"
                @nextClick="saveForms()"
                mode="edit"
            >
                <template v-slot:title-solt>
                </template>
                <template v-slot:content-solt>
                    <AppForm
                        ref="appForm"
                        v-model="formData"
                        :toggleContact="showAccount"
                    />
                </template>
            </PanelV2>
        </PageContent>
    </div>
</template>

<script>
    import AppForm from "../forms/NewMerchantCorpH.val";
    import API from "@/api";
    export default {
        name: 'EditSettlement',
        components:{
            AppForm
        },
        data() {
            return {
                formData: {
                    accountName: '',
                    accountNumber: '',
                    bankType: '',
                },
                showAccount: true,
            }
        },
        created() {
            this.init()
        },
        mounted() {
            this.$refs.appForm.$refs.appForm.clearValidate()
        },
        watch: {
            'formData.bankType'(val) {
                this.showAccount = (val !== '3' && val != '')
                if (val == '3') {
                    this.formData.accountName = ''
                    this.formData.accountNumber = ''
                } else {
                    this.$refs.appForm.$refs.appForm.clearValidate()
                }
            }
        },
        methods: {
            init() {
                API.getBdoProcessData({
                    token: this.getCookieItem('token'),
                    pageNo: 999,
                }).then((res) => {
                    this.formData.bankType = res.obj.settlementAccount.bankType
                    this.formData.accountName = res.obj.settlementAccount.accountName
                    this.formData.accountNumber = res.obj.settlementAccount.accountNumber
                })
            },
            saveForms() {
                this.$refs.appForm.$refs.appForm.validate((valid) => {
                    if (!valid && this.formData.bankType != 3) {
                        return
                    }
                    API.editBdoProcess({
                        token: this.getCookieItem('token'),
                        pageNo: '10',
                        settlementAccount: this.formData
                    }).then(res => {
                        if(res.success) {
                            window.history.go(-1);
                        }
                    })
                });
            }
        }
    }
</script>


<style lang="scss" scoped>
.edit-settlement {
    .panel-v2.content-area {
        margin: 16px 0;
    }
    ::v-deep.content {
        padding: 0;
    }
    .el-form-item:nth-child(4) {
        margin-top: -120px;
    }
}
</style>
